<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="SearchIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="selectRecord"  />
      <!-- <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord"  /> -->
      <feather-icon icon="ClockIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openVersionPopup" />
      <!-- <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm" /> -->
    </div>
</template>

<script>
export default {
  name: 'CellMuckActions',
  methods: {
    selectRecord () {
      this.params.context.componentParent.selectMuck(this.params.data);
    },
    editRecord () {
      this.params.context.componentParent.editMuck(this.params.data);
    },
    openVersionPopup () {
      this.params.context.componentParent.openVersionPopup(this.params.data);
    },
    openDeleteConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('GradeControl.Muck.ConfirmDelete'),
        accept: this.deleteRecord
      });
    },

    deleteRecord () {
      this.params.context.componentParent.deleteMuck(this.params.data.muckId);
    }
  }
}
</script>
